require([
    'jquery'
],
    ($) => {
        'use strict';

        const productFilters = (() => {
            const $filters = $('.toolbar-sorter');
            const $filtersToggle = $('.toggle-filters');
            const activeClass = 'filters-open';
            const toggleActiveClass = 'toggle-active';

            const toggleFilters = () => {
                $filters.toggleClass(activeClass);
                $filtersToggle.toggleClass(toggleActiveClass);
            };

            const addEvents = () => {
                $filtersToggle.on('click', toggleFilters);
            };

            const init = () => {
                addEvents();
            };

            return {
                init
            };

        })();

        productFilters.init();
    });
